import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

import type { OverChargeClaimComment, OverChargeClaimItem, OverChargeClaimSettlement } from '../../types';

export type SaveOCClaimRequestParams = {
  fbOcKey: number;
  claimItem?: OverChargeClaimItem[];
  claimComment?: OverChargeClaimComment[];
  claimSettlement?: OverChargeClaimSettlement[];
  [key: string]: unknown;
};

export const saveOCClaimAPI = (data: SaveOCClaimRequestParams) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.OVERCHARGE_CLAIM}/SaveClaim`,
  });
};

export type SaveOCClaimResponse = number;

export const saveOCClaim = async (data: SaveOCClaimRequestParams): Promise<SaveOCClaimResponse> => {
  const response: AxiosResponse<SaveOCClaimResponse> = await saveOCClaimAPI(data);
  return response.data;
};
